export default "__VITE_ASSET__fc72d03a__"